import { render } from "./ProdutoDetalheView.vue?vue&type=template&id=4f7e4584"
import script from "./ProdutoDetalheView.vue?vue&type=script&lang=js"
export * from "./ProdutoDetalheView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__